import { api } from '@/lib/api'
import type {
  DeleteHistoryPayload,
  HistoryEntry,
  HistorySource,
  HistoryTransaction,
} from './types'

export const dataHistoryApi = {
  list: (source: HistorySource) =>
    api.get<HistoryEntry[]>(`/api/history/${source}`),
  transactionsByHistory: (source: HistorySource, id: string) =>
    api.get<HistoryTransaction[]>(`/api/history/${source}/${id}/transactions`),
  requestDeleteCode: () =>
    api.post<{ message?: string }>('/api/auth/request-delete-code', { context: 'history' }),
  deleteOne: (id: number, payload: DeleteHistoryPayload) =>
    api.del<{ message?: string }>(`/api/history/${id}`, { body: payload }),
  deleteSource: (source: HistorySource, payload: DeleteHistoryPayload) =>
    api.del<{ message?: string }>(`/api/history/source/${source}`, { body: payload }),
}
